<template>
<div>
    <div class="trialdialog-container">
        <img src="../../assets/images/trial.png" />
        <h4>{{ $t('explore.expired.title') }}</h4>
        <p>{{ $t('explore.expired.caption') }}</p>

        <p v-if="enabledFeatures['premiumSection'] === false" style="padding: 10px; border: 1px solid rgba(var(--vs-primary), 0.5); border-radius: 5px; background: rgba(var(--vs-primary), 0.01); color: rgba(var(--vs-primary)); font-size: 0.8rem; margin-top: 10px;">
            {{ $t('profile.subscription.notAvailable') }}
        </p>

        <vs-button size="large" block @click="callback(true, true)" v-if="enabledFeatures['premiumSection'] !== false">
            {{ $t('explore.expired.button') }}
        </vs-button>
    </div>

</div>
</template>

    
<script>
export default {
    name: 'trialDialog',
    props: {
        callback: Function
    },

    computed: {
        enabledFeatures() {
            return this.$FEATURES.settings;
        }
    }
}
</script>

    
<style scoped>
p,
h4 {
    margin: 0;
}

img {
    margin-bottom: 20px;
}

.trialdialog-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding-top: 40px;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
}
</style>
